export const registrationOtpLength = 6
const turboStreamContentType = 'text/vnd.turbo-stream.html'

// A failed submission that the server did not answer itself: 422 is a normal
// validation re-render and Turbo Stream responses carry their own toast.
export const isUnhandledFailure = (fetchResponse) => {
  if (!fetchResponse || fetchResponse.redirected) return false

  const status = fetchResponse.statusCode ?? fetchResponse.response?.status
  if (!status || (status >= 200 && status < 400) || status === 422) return false

  const contentType = fetchResponse.contentType ?? fetchResponse.response?.headers?.get('Content-Type') ?? ''
  return !contentType.startsWith(turboStreamContentType)
}

export const normalizeOtp = (value) => String(value ?? '').replace(/\D/g, '').slice(0, registrationOtpLength)
